import React, { useState, Fragment } from "react";
import { Document, Page } from "react-pdf";
import "./index.css";

const PDFViewerModal = ({ pdfUrl }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <div
      className="modal fade modal-container"
      id="view_pdf_dialog"
      tabIndex="1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
      style={{ zIndex: 10000 }}
    >
      <div className="modal-dialog" style={{ maxWidth: 800 }} role="document">
        <div className="modal-content" style={{ width: 800, height: 750 }}>
          <div className="modal-header">
            <h5 className="modal-title">Document</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            className="modal-body pb-1"
            style={{ height: 570, fontSize: 12, overflowY: "auto" }}
          >
            <Document file={`${pdfUrl}`} onLoadSuccess={onDocumentLoadSuccess}>
              {Array.from(new Array(numPages), (el, index) => (
                <Fragment key={index}>
                  <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                  <p>
                    Page {pageNumber} of {numPages}
                  </p>
                </Fragment>
              ))}
            </Document>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PDFViewerModal;



// WEBPACK FOOTER //
// ./src/components/PDFViewer/index.js